var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane",attrs:{"role":"tabcard","id":"dashboard"}},[_c('div',{staticClass:"card card-default"},[_c('div',{staticClass:"card-header"},[_vm._v("Dashboard")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n            Your application's dashboard.\n        ")])])])
}]

export { render, staticRenderFns }